<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="级别1-8:D-SSS+" prop="levelName" >
        <a-input v-model="form.levelName" placeholder="请输入级别1-8:D-SSS+" />
      </a-form-model-item>
      <a-form-model-item label="级别名称描述" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="升级所需的剧评数" prop="replayNum" >
        <a-input v-model="form.replayNum" placeholder="请输入升级所需的剧评数" />
      </a-form-model-item>
      <a-form-model-item label="升级所需的点赞数" prop="likeNum" >
        <a-input v-model="form.likeNum" placeholder="请输入升级所需的点赞数" />
      </a-form-model-item>
      <a-form-model-item label="升级所需的通过平台评价数量" prop="platReplayNum" >
        <a-input v-model="form.platReplayNum" placeholder="请输入升级所需的通过平台评价数量" />
      </a-form-model-item>
      <!--      <a-form-model-item label="排序" prop="sort" >
        <a-input v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="逻辑删除标记，1：删除，0：未删除，默认0" prop="isDeleted" v-if="formType === 1">
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记，1：删除，0：未删除，默认0" />
      </a-form-model-item>

      <a-form-model-item label="乐观锁" prop="version" v-if="formType === 1">
        <a-input v-model="form.version" placeholder="请输入乐观锁" />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReplyLevel, addReplyLevel, updateReplyLevel } from '@/api/config/replyLevel'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        levelName: null,

        replayNum: null,

        likeNum: null,

        sort: null,

        createTime: null,

        updateTime: null,

        creator: null,

        modifier: null,

        isDeleted: null,

        remark: null,

        version: null,

        platReplayNum: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        levelName: [
          { required: true, message: '级别名称不能为空', trigger: 'blur' }
        ],

        // replayNum: [
        //   { required: true, message: '升级所需的剧评数不能为空', trigger: 'blur' }
        // ],
        //
        // likeNum: [
        //   { required: true, message: '升级所需的点赞数不能为空', trigger: 'blur' }
        // ],

        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],

        isDeleted: [
          { required: true, message: '逻辑删除标记，1：删除，0：未删除，默认0不能为空', trigger: 'blur' }
        ],

        version: [
          { required: true, message: '乐观锁不能为空', trigger: 'blur' }
        ]

        // platReplayNum: [
        //   { required: true, message: '升级所需的通过平台评价数量不能为空', trigger: 'blur' }
        // ]

      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,

        levelName: null,

        replayNum: null,

        likeNum: null,

        sort: null,

        createTime: null,

        updateTime: null,

        creator: null,

        modifier: null,

        isDeleted: null,

        remark: null,

        version: null,

        platReplayNum: null

      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReplyLevel(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReplyLevel(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReplyLevel(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
